import React from 'react';
import styled from 'styled-components';

const StyledServicesSection = styled.section`
  padding: 100px 150px;
  max-width: 1000px;
  margin: 0 auto;

  h2 {
    display: flex;
    align-items: center;
    position: relative;
    margin: 10px 0 40px;
    width: 100%;
    font-size: clamp(26px, 5vw, 32px);
    white-space: nowrap;

    &:after {
      content: '';
      display: block;
      position: relative;
      top: 0;
      width: 300px;
      height: 1px;
      margin-left: 20px;
      background-color: var(--lightest-navy);
    }
  }
`;

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
`;

const StyledService = styled.div`
  padding: 2rem 1.75rem;
  background-color: var(--light-navy);
  border-radius: 4px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    transform: translateY(-7px);
  }

  h3 {
    margin: 0 0 10px;
    font-size: 20px;
    color: var(--lightest-slate);
  }

  p {
    color: var(--light-slate);
  }
`;

const services = [
  {
    title: 'Custom AI Development',
    description: 'We design and build bespoke AI models tailored to your specific business needs, from natural language processing to computer vision.',
  },
  {
    title: 'Machine Learning Solutions',
    description: 'Leverage our expertise in machine learning to unlock predictive insights, automate processes, and drive data-driven decisions.',
  },
  {
    title: 'AI Integration Services',
    description: 'Seamlessly integrate cutting-edge AI capabilities into your existing software infrastructure and workflows.',
  },
  {
    title: 'Web Development',
    description: 'We build scalable and secure web applications tailored to your business needs, from marketing sites to complex enterprise apps.'
  },
  {
    title: 'Mobile App Development',
    description: 'We create engaging and high-performing mobile applications for iOS and Android, reaching your customers on their favorite devices.'
  },
  {
    title: 'Cloud App Development',
    description: 'Leverage the power of the cloud to build scalable, resilient, and cost-effective applications.'
  },
];

const Services = () => (
  <StyledServicesSection id="services">
    <h2>Our Services</h2>
    <StyledGrid>
      {services.map((service, i) => (
        <StyledService key={i}>
          <h3>{service.title}</h3>
          <p>{service.description}</p>
        </StyledService>
      ))}
    </StyledGrid>
  </StyledServicesSection>
);

export default Services;